import React, { FC } from 'react'

import { Box } from '@popmenu/common-ui'
import { Button } from '../Button'
import { FullScreenStepperActionsProps } from './FullScreenStepperActionsProps'
import { useFullScreenStepperActionsStyles } from './FullScreenStepperActionsStyles'
import { StepperActionsCancelButton } from './util/StepperActionsCancelButton'
import { StepperActionsNextButton } from './util/StepperActionsNextButton'
import { StepperActionsPreviousButton } from './util/StepperActionsPreviousButton'
import { StepperActionsStatusText } from './util/StepperActionsStatusText'

export const FullScreenStepperActions: FC<FullScreenStepperActionsProps> = (props) => {
  const {
    stepCount,
    stepCursor,
    setStepCursor,
    handleNextClick,
    handlePreviousClick,
    handleCancelClick,
    actions,
    callbackArgs,
    cancelButtonText,
    nextButtonText,
    finishButtonText,
    nextButtonProps,
    previousButtonText,
    previousButtonProps,
    cancelButtonProps,
    statusText,
    displayPreviousButton,
    displayCancelButton,
  } = props
  const classes = useFullScreenStepperActionsStyles(props)

  return (
    <Box className={classes.root}>
      <Box className={classes.inlineStartActions}>
        <StepperActionsPreviousButton
          displayPreviousButton={displayPreviousButton}
          previousButtonText={previousButtonText}
          handlePreviousClick={handlePreviousClick}
          previousButtonProps={previousButtonProps}
          stepCursor={stepCursor}
          setStepCursor={setStepCursor}
        />
        <StepperActionsStatusText statusText={statusText} />
      </Box>
      <Box className={classes.inlineEndActions}>
        {actions &&
          actions.map((action, i) => (
            <Button
              key={`custom-action-${stepCursor}-${i}`}
              variant="ghost"
              onClick={(event: React.MouseEvent<HTMLButtonElement>) => action.onClick(event, callbackArgs)}
              {...action.props}
            >
              {action.text}
            </Button>
          ))}
        <StepperActionsCancelButton
          setStepCursor={setStepCursor}
          stepCursor={stepCursor}
          cancelButtonText={cancelButtonText}
          cancelButtonProps={cancelButtonProps}
          handleCancelClick={handleCancelClick}
          displayCancelButton={displayCancelButton}
        />
        <StepperActionsNextButton
          handleNextClick={handleNextClick}
          nextButtonProps={nextButtonProps}
          setStepCursor={setStepCursor}
          stepCursor={stepCursor}
          stepCount={stepCount}
          finishButtonText={finishButtonText}
          nextButtonText={nextButtonText}
        />
      </Box>
    </Box>
  )
}
